import React from "react";

const Pagination = ({ page, total, pageSize = 50, onChange }) => {
  const totalPages = Math.max(1, Math.ceil(total / pageSize));

  const goto = (p) => {
    const clamped = Math.max(1, Math.min(totalPages, p));
    if (clamped !== page) onChange(clamped);
  };

  return (
    <div className="mt-3 flex flex-wrap items-center justify-between gap-3">
      <div className="text-xs text-gray-600">
        Showing <span className="font-semibold">{(page - 1) * pageSize + 1}</span>–
        <span className="font-semibold">{Math.min(page * pageSize, total)}</span> of{" "}
        <span className="font-semibold">{total}</span>
      </div>

      <div className="flex items-center gap-1">
        <button
          onClick={() => goto(1)}
          className="rounded-lg border bg-white px-2 py-1 text-xs hover:bg-gray-50"
          disabled={page === 1}
        >
          « First
        </button>
        <button
          onClick={() => goto(page - 1)}
          className="rounded-lg border bg-white px-2 py-1 text-xs hover:bg-gray-50"
          disabled={page === 1}
        >
          ‹ Prev
        </button>

        <span className="mx-2 text-xs text-gray-700">
          Page <span className="font-semibold">{page}</span> / {totalPages}
        </span>

        <button
          onClick={() => goto(page + 1)}
          className="rounded-lg border bg-white px-2 py-1 text-xs hover:bg-gray-50"
          disabled={page === totalPages}
        >
          Next ›
        </button>
        <button
          onClick={() => goto(totalPages)}
          className="rounded-lg border bg-white px-2 py-1 text-xs hover:bg-gray-50"
          disabled={page === totalPages}
        >
          Last »
        </button>
      </div>
    </div>
  );
};

export default Pagination;
